import Document from "@/views/document/Document";

export default [
    {
        path: '/documents',
        name: 'Document',
        meta: {layout: 'on-boarding',authRequired:true},
        component: Document,
    },
]